import { render, staticRenderFns } from "./BinanceSocket.vue?vue&type=template&id=11f05cd4&"
import script from "./BinanceSocket.vue?vue&type=script&lang=js&"
export * from "./BinanceSocket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports